import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Form, Loader, Message } from 'semantic-ui-react';
import { getWithAuth } from 'src/api';

export const SM_TEMPLATE_ID_KEY = 'cn.lp.pmplinktemplateid';

export const PMPLinkTemplate = ({ trigger = null }) => {
  const [projectId, pmpLinks] = useSelector((state: any) => [
    state.mainFrame.projectId,
    state.mainFrame.pmpLinks,
  ]);

  const storedId = localStorage.getItem(SM_TEMPLATE_ID_KEY);
  const [selected, setSelected] = useState(storedId);

  const smIds = pmpLinks?.features.map((sm) => sm.properties.sm_id) ?? [];
  const queryKey = [projectId, ...smIds];

  const { data: smSummary, isLoading } = useQuery({
    queryKey,
    queryFn: async () => {
      return await getWithAuth(`project/${projectId}/subscribers/summary`);
    },
    initialData: null,
    retry: false,
    enabled: true,
  });

  useEffect(() => {
    if (!smIds.includes(selected) && selected !== 'none') {
      setSelected('none');
    }
  }, [smIds, storedId]);

  if (isLoading || smSummary === null || pmpLinks == null) {
    return <Loader active inline />;
  }

  const summaryLookup = Object.fromEntries(smSummary.map((sm) => [sm.id, sm]));

  let nameOptions = [
    { key: 'none', text: '<no template - default settings>', value: 'none' },
  ];

  if (pmpLinks.features) {
    const linkOptions = pmpLinks.features
      .map((f, idx) => {
        const smId = f.properties.sm_id;
        const name = f.properties.name.split(' to ')[1].trim();
        const summaryInfo = summaryLookup[smId];
        let textLabel = name;
        if (summaryInfo) {
          textLabel += ` [${summaryInfo.bands} / ${summaryInfo.products}]`;
        }
        return { key: `${idx}-${name}`, text: textLabel, value: smId };
      })
      .sort((o1, o2) => o1.text.localeCompare(o2.text));

    nameOptions = nameOptions.concat(linkOptions);
  }

  return (
    <Form.Field>
      <label>
        <FormattedMessage
          id="ptpMode.existingSubscriber"
          defaultMessage="Configure From Existing Subscriber"
        />
      </label>
      <Form.Select
        options={nameOptions}
        value={selected}
        onChange={(_, data) => {
          let newId = data.value.toString();
          if (data.value.toString() === 'none') {
            newId = '';
            localStorage.removeItem(SM_TEMPLATE_ID_KEY);
          } else {
            localStorage.setItem(SM_TEMPLATE_ID_KEY, newId);
          }
          setSelected(newId);
          if (trigger) {
            trigger(newId);
          }
        }}
      />
      <Message info>
        The selected template will only apply the attributes that are supported
        by the parent Network Device configuration. Equivalent or default values
        will be used when the template value is not valid.
      </Message>
    </Form.Field>
  );
};
